import { useContext } from "react"
import { AppContext } from "../../components"

export const useSsoService = () => {
  const { sso } = useContext(AppContext)
  return sso
}
